import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=0434f582"
import script from "./IssueStatus.vue?vue&type=script&lang=js"
export * from "./IssueStatus.vue?vue&type=script&lang=js"
import style0 from "./IssueStatus.vue?vue&type=style&index=0&id=0434f582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports